import React from 'react';
import { StyledLink } from './styles';
import useBodega from './../../utils/hooks/bodegaHook';
import { SKIP_TO_A11Y } from '../../constants';
import useFeatureFlags from '../../utils/hooks/featureFlagsHook';

function SkipToAccessibility() {
  const showSkipToA11y = useFeatureFlags(SKIP_TO_A11Y);
  if (!showSkipToA11y) {
    return null;
  }
  const label = useBodega('nav_accessibility_at_nike', 'Accessibility at Nike');
  return <StyledLink href="https://www.nike.com/accessibility#introduction">{label}</StyledLink>;
}

export default SkipToAccessibility;
